import { type GroupChannel } from '@sendbird/chat/groupChannel';
import { useCallback } from 'react';

import { buildChannelDataWithDocumentVaultDisplayName } from '../utils/documentVaultChannelData';

export const useUpdateDocumentVaultDisplayName = (
    channel: GroupChannel | null,
) => {
    const updateDisplayName = useCallback(
        async (
            messageId: number,
            displayName: string,
        ): Promise<GroupChannel> => {
            if (channel == null) {
                throw new Error('Messaging channel is not available');
            }

            const data = buildChannelDataWithDocumentVaultDisplayName(
                channel.data,
                messageId,
                displayName,
            );

            return await channel.updateChannel({ data });
        },
        [channel],
    );

    return { updateDisplayName };
};
